<template>
	<v-footer absolute class="font-weight-medium footer-frame">
		<v-container>
			<v-row>
				<v-col cols="6" sm="3" md="2" class="pr-0 pr-md-3">
					<div class="text-uppercase text-caption font-weight-bold pb-2">HWI</div>
					<div class="text-caption">
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Tentang Kami</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Produk</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Blog</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Mitra Kami</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Testimonial</div>
						</router-link>
					</div>
				</v-col>
				
				<v-col cols="6" sm="3" md="2" class="pl-0 pl-md-3">
					<div class="text-uppercase text-caption font-weight-bold pb-2">Layanan &amp; Bantuan</div>
					<div class="text-caption">
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Syarat &amp; Ketentuan</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Kebijakan Privasi</div>
						</router-link>
						<router-link :to="'#'" class="text-deco black--text">
							<div class="pt-1 text-capitalize">Hubungi Kami</div>
						</router-link>
					</div>
				</v-col>
				
				<v-col cols="6" sm="3" md="3" class="pl-0 pl-md-3">
					<div class="text-uppercase text-caption font-weight-bold pb-2">Pembayaran</div>
					<div>
						<v-col class="py-0">
							<v-row>
								<v-col cols="6" class="pl-0 pr-1 pt-0 pb-1"><v-img eager src="/assets/bank/bca.svg"></v-img></v-col>
								<v-col cols="6" class="pl-0 pr-1 pt-0 pb-1"><v-img eager src="/assets/bank/bri.svg"></v-img></v-col>
							</v-row>
						</v-col>
					</div>
				</v-col>
				<v-col cols="6" sm="3" md="3" class="pr-0 pr-md-3">
					<div class="text-uppercase text-caption font-weight-bold pb-2">Pengiriman</div>
					<div>
						<v-col class="py-0">
							<v-row>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/jne.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/j&t.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/sicepat.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/ninja.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/pos.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/jet.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/lion.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/wahana.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/pahala.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/dse.svg"></v-img></v-col>
								<v-col cols="4" class="pl-0 pl-md-3"><v-img eager src="/assets/courier/pandu.svg"></v-img></v-col>
							</v-row>
						</v-col>
					</div>
				</v-col>
				<v-col cols="4" sm="3" md="2" class="pl-0 pl-md-3">
					<div class="text-uppercase text-caption font-weight-bold pb-2">Ikuti Kami</div>
					<div class="text-caption">
						<div class="d-flex">
							<div><img width="20" src="/assets/sosmed/facebook.svg"></div>
							<div class="pl-2">Facebook</div>
						</div>
						<div class="d-flex pt-1">
							<div><img width="20" src="/assets/sosmed/twitter.svg"></div>
							<div class="pl-2">Twitter</div>
						</div>
						<div class="d-flex pt-1">
							<div><img width="20" src="/assets/sosmed/instagram.svg"></div>
							<div class="pl-2">Instagram</div>
						</div>
						<div class="d-flex pt-1">
							<div><img width="20" src="/assets/sosmed/line.svg"></div>
							<div class="pl-2">WhatsApp</div>
						</div>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-2 pb-0 px-0 pt-md-0 px-md-3">
					<v-divider></v-divider>
					<div class="pt-4 pb-1 text-caption">PT. Healthwealth International {{ new Date().getFullYear() }}. Hak Cipta Dilindungi</div>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
// import { mapActions, mapState } from "vuex";

export default {
	computed: {
		// ...mapState("content", ["content"]),
	},
	methods: {
		// ...mapActions("content", ["getContent"]),
	},
	created() {
		// this.getContent()
	},
};
</script>